import { createFeature, createReducer, on } from '@ngrx/store';
import { RouteModels } from '@share-models';
import { RouteActions } from './route.action-types';

export declare interface RouteState {
  breadcrumbs: RouteModels.UiBreadCrumbItem[];
}

export const initialState: RouteState = {
  breadcrumbs: [],
};

export const routeStateReducer = createReducer(
  initialState,
  on(RouteActions.resetToInitialState, () => {
    return {
      ...initialState,
    };
  }),
  on(RouteActions.setBreadcrumbs, (state, { breadcrumbs }) => {
    return {
      ...state,
      breadcrumbs,
    };
  }),
);

export const routeFeature = createFeature({
  name: 'route',
  reducer: routeStateReducer,
});
